import image1 from "../../images/ps.jpg";
import image2 from "../../images/ac.jpg";
import image3 from "../../images/bat.jpg";
import image4 from "../../images/clutch.jpg";
import image5 from "../../images/dap.jpg";
import image6 from "../../images/rep.jpg";
import image7 from "../../images/wiper.jpg";
export const offers = [
    {
        title: "Get 1st Inspection Free",
        desc: "Redeem your free car home inspection. Valid for first time users.",
        image: image1,
        code: "GFIF12X3A",
    },
    {
        title: "40% off",
        desc: "Get flat 40% off on periodic services now.",
        image: image2,
        code: "GFIF40ZA",
    },
    {
        title: "40% off",
        desc: "Get flat 40% off on periodic services now.",
        image: image3,
        code: "GFIF40ZA",
    },
    {
        title: "40% off",
        desc: "Get flat 40% off on periodic services now.",
        image: image4,
        code: "GFIF40ZA",
    },
    {
        title: "40% off",
        desc: "Get flat 40% off on periodic services now.",
        image: image5,
        code: "GFIF40ZA",
    },
    {
        title: "40% off",
        desc: "Get flat 40% off on periodic services now.",
        image: image6,
        code: "GFIF40ZA",
    },
    {
        title: "40% off",
        desc: "Get flat 40% off on periodic services now.",
        image: image7,
        code: "GFIF40ZA",
    },
];
